var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _syncCartTriggerAriaExpanded, _onDrawerStateChange, _onCartUpdate;
import { Component } from "@theme/component";
import { StandardEvents, CartLinesUpdateEvent } from "@shopify/events";
import { DrawerOpenEvent, DrawerCloseEvent } from "@theme/theme-drawer";
class HeaderActions extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "requiredRefs", ["liveRegion"]);
    __privateAdd(this, _syncCartTriggerAriaExpanded, () => {
      const cartDrawer = document.getElementById("cart-drawer");
      if (!cartDrawer) return;
      const trigger = this.querySelector('[aria-controls="cart-drawer"]');
      if (!trigger) return;
      trigger.setAttribute("aria-expanded", cartDrawer.hasAttribute("open") ? "true" : "false");
    });
    __privateAdd(this, _onDrawerStateChange, (event) => {
      const target = (
        /** @type {HTMLElement | null} */
        event.target
      );
      if ((target == null ? void 0 : target.id) !== "cart-drawer") return;
      __privateGet(this, _syncCartTriggerAriaExpanded).call(this);
    });
    __privateAdd(this, _onCartUpdate, (event) => {
      if (!this.contains(event.target)) return;
      const count = event.detail && event.detail.count;
      if (!Number.isInteger(count) || count < 0) return;
      const text = "".concat(Theme.translations.cart_count, ": ").concat(count);
      if (this.refs.liveRegion.textContent !== text) this.refs.liveRegion.textContent = text;
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("pb:cart-count-confirmed", __privateGet(this, _onCartUpdate));
    document.addEventListener(DrawerOpenEvent.eventName, __privateGet(this, _onDrawerStateChange));
    document.addEventListener(DrawerCloseEvent.eventName, __privateGet(this, _onDrawerStateChange));
    __privateGet(this, _syncCartTriggerAriaExpanded).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("pb:cart-count-confirmed", __privateGet(this, _onCartUpdate));
    document.removeEventListener(DrawerOpenEvent.eventName, __privateGet(this, _onDrawerStateChange));
    document.removeEventListener(DrawerCloseEvent.eventName, __privateGet(this, _onDrawerStateChange));
  }
}
_syncCartTriggerAriaExpanded = /* @__PURE__ */ new WeakMap();
_onDrawerStateChange = /* @__PURE__ */ new WeakMap();
_onCartUpdate = /* @__PURE__ */ new WeakMap();
if (!customElements.get("header-actions")) {
  customElements.define("header-actions", HeaderActions);
}
